"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Xmlns = void 0;
/**
 * Encapsulates the tags contained within the xmlns-header tags of a BPMN file.
 */
class Xmlns {
}
exports.Xmlns = Xmlns;
//# sourceMappingURL=XMLNS.js.map